import http from '../plugins/axios'

export const getCategorysList = async (params) => {
  try {
    const response = await http.get(`/api/v2/categories`, { params })
    return response
  } catch (error) {
    throw error
  }
}

export const getDetailCategory = async (categoryId, params) => {
  try {
    const response = await http.get(`/api/v2/categories/${categoryId}`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addCategory = async (payload) => {
  try {
    const response = await http.post(`/api/v2/categories`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateCategory = async (categoryId, payload) => {
  try {
    const response = await http.put(`/api/v2/categories/${categoryId}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const uploadImage = async (categoryId, payload) => {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  try {
    const response = await http.post(`/api/v2/categories/${categoryId}/image`, payload, config)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteCategory = async (categoryId, payload) => {
  try {
    const response = await http.delete(`/api/v2/categories/${categoryId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getCategoryTotalProducts = async (categoryId) => {
  try {
    const response = await http.get(`/api/v2/categories/${categoryId}/total-products`)
    return response.data
  } catch (error) {
    throw error
  }
}


export const getCategoryRules = async (params) => {
  try {
    const response = await http.get(`/api/v2/category-rules`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}
